/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskDetailEmailThreadMode = typeof TaskDetailEmailThreadMode[keyof typeof TaskDetailEmailThreadMode] | null;


export const TaskDetailEmailThreadMode = {
  new_thread: 'new_thread',
  reply: 'reply',
} as const;
